import React from 'react';
import { Tooltip } from '@mui/material';
import descriptionIcon from '../../../../assets/images/note.png';

function DescriptionCell({
    value
}) {
    return (
        (value && value !== 'None' && value !== '{{SMP.NONE}}') ? (
            <Tooltip placement="right" title={value}>
                <img src={descriptionIcon} alt="" />
            </Tooltip>
        ) : (
            null
        )
    );
}

export default DescriptionCell;